import { FC } from 'react';
import { IBlockDetail } from 'core/types/Models/linkType';
import RenderHtml from 'components/UI/RenderHtml/RenderHtml';

interface IPreviewTemplateDivider {
  block: IBlockDetail;
}

const PreviewTemplateDivider: FC<IPreviewTemplateDivider> = ({ block }) => {
  return (
    <div className='flex justify-center'>
      <RenderHtml data={block.code + ''} />
    </div>
  );
};

export default PreviewTemplateDivider;
